// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyToClipboard_container__3rzPq","blur":"CopyToClipboard_blur__3R717"};